

// export const URL = "http://localhost:7142/api/";

// export const  URL = "https://urban-mathematical-supporters-highways.trycloudflare.com/api/";
export const URL = "https://HumayaDigital.com/mh/apihumayadigital/api/";

 export const pathimagenes = "/static/media/imagenes";

 